<template>
	<div class="toplist">
		<h2 class="level-one-heading mb-5">Topplistor</h2>
		<hr>
		<div class="mb-5">
			I vår Hall of Fame finner du de medlemmar som har låst upp flest achievements, fått ihop mest experience points, samlat flest supply drops, skrivit flest recensioner, svarat på flest frågor och tyckt till mest om recensioner, frågor och svar. Hur ligger du och dina vänner till?
		</div>
		<loading-spinner v-if="isLoading" />
		<div v-else>
			<div class="list-settings dropdown-container">
				<dropdown-select
					v-model="inputSort"
					:formatter="tt"
					:placeholder="0"
					:items="sortingOptionsToplists"
				/>
				<dropdown-select
					v-model="inputFilter"
					:formatter="tt"
					:placeholder="0"
					:items="sortingOptionsMembers"
				/>
			</div>
			<div
				v-for="(user, index) in users"
				:key="'member-toplist-' + index"
				:class="['panel toplist-container', { 'user-border': user.id === currentUserId }]"
			>
				<div class="toplist-number-container">{{ index === 25 ? '...' : index + 1 }}</div>
				<ximg
					class="pixelated"
					:style="{
						backgroundImage: getBackgroundUrl(user),
					}"
					:src="'/api/avatar/' + user.id"
					lazy
					:ariaLabel="user.username ? user.username + ' avatar' : 'No face avatar'"
					role="img"
				/>
				<div class="toplist-user-info">
					<router-link
						v-if="user.username && user.isPublicProfile"
						class="username"
						:to="userPath(user)"
					>
						{{ user.username }}
					</router-link>
					<span v-else class="secondary username">Dolt namn</span>
					<span class="hidden-sm hidden-xs secondary">
						Lvl {{ user.rankLevel }} {{ user.avatar.class.title }}
					</span>
					<div v-if="isMobile" class="right-container-mobile">
						<div class="sort-value-wrapper">
							<img :src="convertToCdnUrl(toplistIcon)" alt="top-list-icon" >
							<span>
								{{ user.sortValue }}
							</span>
						</div>
						<div class="achievements-wrapper">
							<ximg
								v-for="achievement in user.achievements"
								:key="achievement.id"
								:title="achievement.name"
								:src="convertToAchievementUrl(achievement.imageName, 32, 32)"
								:fallback="convertToAchievementUrl('404', 32, 32)"
								lazy
								:ariaLabel="achievement.name"
								role="img"
							/>
						</div>
					</div>
				</div>
				<template v-if="! isMobile">
					<div class="right-container">
						<div class="achievements-wrapper">
							<ximg
								v-for="achievement in user.achievements"
								:key="achievement.id"
								:title="achievement.name"
								:src="convertToAchievementUrl(achievement.imageName, 47, 47)"
								:fallback="convertToAchievementUrl('404', 47, 47)"
								lazy
								:ariaLabel="achievement.name"
								role="img"
							/>
						</div>
						<div class="sort-value-wrapper">
							<img :src="convertToCdnUrl(toplistIcon)" alt="toplist">
							<span> {{ user.sortValue }} </span>
						</div>
					</div>
				</template>
				<div class="clearfix" />
			</div>
		</div>
	</div>
</template>

<script>
import waja from 'waja';
import mq from 'mediaQuery';
import { urlFormat, convertToCdnUrl, convertToAchievementUrl, memberRoute } from 'utils';
import { t } from 'datastore/i18n';
import memberUtils from 'utils/member';
import { mapGetters } from 'vuex';

export default {
	props: ['user'],
	data () {
		return {
			users: [],
			isLoading: true,
			mq,
			groupAchievements: false,
			sortingOption: 'latest',
			sortingOptionsToplists: [
				{
					value: 'achievements',
					label: this.tt('ACHIEVEMENTS'),
				},
				{
					value: 'experience_points',
					label: this.tt('EXPERIENCE_POINTS'),
				},
				{
					value: 'supply_drops',
					label: this.tt('SUPPLY_DROPS'),
				},
				{
					value: 'reviews',
					label: this.tt('REVIEWS'),
				},
				{
					value: 'answers',
					label: this.tt('ANSWERS'),
				},
				/*{
					value: 'votes',
					label: this.tt('VOTES'),
				},*/
			],
			sortingOptionsMembers: [
				{
					value: '?allMembers',
					label: this.tt('ALL_MEMBERS'),
				},
				{
					value: '?onlyFriends',
					label: this.tt('FRIENDS'),
				},
				{
					value: this.rankLevel,
					label: this.tt('MY_RANK'),
				},
			],
			inputSort: 'achievements',
			inputFilter: '',
		};
	},
	methods: {
		convertToCdnUrl,
		convertToAchievementUrl,
		urlFormat,
		getBackgroundUrl: memberUtils.getBackgroundUrl,
		tm: t.prefix('MEMBER'),
		tt: t.prefix('TOPLIST'),

		loadTopList () {
			this.isLoading = true;
			waja.get(this.endPoint)
				.on('success', res => {
					this.users = res.data.users;
					this.isLoading = false;
				}).go();
		},
		userPath (user) {
			return this.$router.route(memberRoute(user, 'member.achievements'));
		},
	},
	computed: {
		toplistIcon () {
			switch (this.inputSort) {
				case 'achievements':
					return '/img/icons/feed/feed_achievement.svg';
				case 'experience_points':
					return '/img/icons/feed/feed_xp.svg';
				case 'supply_drops':
					return '/img/icons/feed/feed_supply.svg';
				case 'reviews':
					return '/img/icons/feed/feed_review.svg';
				case 'answers':
					return '/img/icons/feed/feed_answer.svg';
				case 'votes':
					return '/img/icons/feed/feed_upvote.svg';
			}
		},
		endPoint () {
			return `list/user/${this.inputSort}/${this.inputFilter}`;
		},

		isMobile () {
			return this.mq.current <= this.mq.sm;
		},
		...mapGetters({
			rankLevel: 'user/rankLevel',
			currentUserId: 'user/currentUserId'
		}),
	},
	mounted () {
		this.sortingOptionsMembers[2].value = this.rankLevel;
		this.loadTopList();
	},
	watch: {
		inputSort () {
			this.loadTopList();
		},
		inputFilter () {
			this.loadTopList();
		}
	}
};
</script>
